/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */

import './MarginJournalPage.scss';

import React from 'react';
import ErrorPage from '../../shared/ErrorPage/ErrorPage';
import { Link } from 'react-router-dom';

const MarginJournalPage = () => {
  return (
    <div className="margin-journal-page-container">
      <ErrorPage summaryMessage="We are unable to process your margin journal request at this time, we apologize for the inconvenience.">
        <div className="error-page-content error-page-message">
          <div>
            For immediate assistance with a transaction or account inquiry,
            please please call a T. Rowe Price Brokerage representative at
            1-866-845-0052, Monday through Friday from 8:00 a.m to 8:00 p.m ET.
          </div>
          <div className="error-page-return error-page-link">
            <Link to="/dashboard">Return to dashboard</Link>
          </div>
        </div>
      </ErrorPage>
    </div>
  );
};

export default MarginJournalPage;
